export function convertToServerFormat(value: any) {
  return value ? String(value) : '';
}

export enum Warning {
  Required = 'Lisää puuttuva tieto',
  SymbolsLimit = 'Kentän maksimi merkkimäärä on 200',
  DescriptionSymbolsLimit = `Kentän maksimi merkkimäärä on 4000`,
}
